<template>
  <div id="editUserInternalPermissionModal">
    <CModal
      :show.sync="showModal"
      size="lg"
      :centered="true"
      :closeOnBackdrop="false"
    >
      <CForm>
        <div class="form-row">
          <CCol tag="label" sm="3" class="col-form-label"> Permissions </CCol>
          <CCol sm="9">
            <template v-for="(permission, index) in permissionList">
              <div class="form-row form-check" :key="index">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :id="permission.value"
                  :value="permission.value"
                  v-model="checkedPermissions"
                  :disabled="isPermissionDisabled(permission.value)"
                  @change="onPermissionChange(permission.value)"
                />
                <label
                  :key="index"
                  :for="permission.value"
                  class="form-check-label"
                  >{{ permission.name }}</label
                >
              </div>
            </template>
            <p v-if="isAdminAccount" class="text-muted small mt-2 mb-0">
              Admin permission cannot be removed for admin accounts named "Admin".
            </p>
            <!-- <span>Checked: {{ checkedPermissions }}</span> -->
          </CCol>
        </div>
      </CForm>
      <template #header>
        <h5 class="modal-title">Edit Permissions</h5>
        <CButtonClose @click="closeModal" />
      </template>
      <template #footer>
        <CButton @click="closeModal" color="secondary">Cancel</CButton>
        <CButton @click="onEdit" color="primary">Save</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { PermissionList } from '@/utils/utils';
import { normalizePermissions } from '@/utils/permissions';

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    permissions: {
      type: Array,
      required: true,
    },
    userName: {
      type: String,
      default: '',
    },
  },
  data: function () {
    return {
      checkedPermissions: this.getInitialPermissions(this.permissions),
    };
  },
  computed: {
    permissionList: function () {
      return PermissionList();
    },
    isAdminAccount() {
      return (this.userName || '').trim().toLowerCase() === 'admin';
    },
    isAdminSelected() {
      return this.checkedPermissions.includes('admin');
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.checkedPermissions = this.getInitialPermissions(this.permissions);
      }
    },
    userName() {
      this.checkedPermissions = this.getInitialPermissions(this.permissions);
    },
    permissions: {
      immediate: true,
      handler(val) {
        this.checkedPermissions = this.getInitialPermissions(val);
      },
    },
  },
  methods: {
    isPermissionDisabled(permissionValue) {
      if (this.isAdminAccount && permissionValue === 'admin') {
        return true;
      }
      if (this.isAdminSelected && permissionValue !== 'admin') {
        return true;
      }
      return false;
    },
    getInitialPermissions(permissions) {
      if (this && this.isAdminAccount) {
        return PermissionList().map((p) => p.value);
      }
      const perms = permissions || [];
      if (perms.includes('admin')) {
        return PermissionList().map((p) => p.value);
      }
      return [...perms];
    },
    closeModal() {
      this.checkedPermissions = this.getInitialPermissions(this.permissions);
      this.$emit('close');
    },
    onEdit() {
      let perms = [...this.checkedPermissions];
      if (this && this.isAdminAccount && !perms.includes('admin')) {
        perms.push('admin');
      }
      this.$emit('save', normalizePermissions(perms));
    },
    onPermissionChange(permission) {
      if (this && this.isAdminAccount && permission === 'admin') {
        if (!this.checkedPermissions.includes('admin')) {
          this.checkedPermissions = PermissionList().map((p) => p.value);
        }
        return;
      }
      if (permission === 'admin') {
        if (this.checkedPermissions.includes('admin')) {
          this.checkedPermissions = PermissionList().map((p) => p.value);
        } else {
          this.checkedPermissions = [];
        }
      }
    },
  },
};
</script>
